import React, { useEffect, useState } from "react";
import Slider1 from "./Slider1";
import "./sundayfeast.css";
import img5 from "./assets/img5.webp";
import Header from "../../../Components/Header/Header";
import Footer from "../../../Components/Footer/Footer";
import img1 from "./assets/img1.webp";
import img2 from "./assets/img2.webp";
import img3 from "./assets/img3.webp";
import img4 from "./assets/img4.webp";
import { CgMail } from "react-icons/cg";
import Slider2 from "./Slider2";
import form_bottom from "./assets/form-bottom.webp";
import { Helmet } from "react-helmet-async";

function SundayFeast() {
  // form data Storing
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    specialNote: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormData({
      name: "",
      email: "",
      phone: "",
      address: "",
      specialNote: "",
    });
    // For future use
  };

  useEffect(() => {
    // Scroll to top on component mount
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Helmet>
        <title>
          Sunday Feast at ISKCON Vijayawada – Prasadam & Spiritual Bliss
        </title>
        <meta
          name="description"
          content="Enjoy ISKCON Vijayawada’s famous Sunday Feast with bhajans, enlightening talks, and delicious prasadam served in a spiritually uplifting atmosphere."
        />
        <meta
          name="keywords"
          content="ISKCON Sunday Feast, Krishna prasadam, free meal ISKCON, Sunday bhakti program"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ISKCON Vijayawada" />
        <meta
          property="og:title"
          content="Sunday Feast at ISKCON Vijayawada – Prasadam & Spiritual Bliss"
        />
        <meta
          property="og:description"
          content="Enjoy ISKCON Vijayawada’s famous Sunday Feast with bhajans, enlightening talks, and delicious prasadam served in a spiritually uplifting atmosphere."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.iskconvijayawada.org/SundayFeast"
        />
        <meta
          property="og:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Sunday Feast at ISKCON Vijayawada – Prasadam & Spiritual Bliss"
        />
        <meta
          name="twitter:description"
          content="Enjoy ISKCON Vijayawada’s famous Sunday Feast with bhajans, enlightening talks, and delicious prasadam served in a spiritually uplifting atmosphere."
        />
        <meta
          name="twitter:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />

        {/* Canonical URL */}
        <link
          rel="canonical"
          href="https://www.iskconvijayawada.org/SundayFeast"
        />
      </Helmet>

      <div className=" w-full">
        <Header />

        <div className="flex flex-col justify-center items-center card1 bg-cover bg-center md:mt-8">
          <div className="flex justify-center mb-8 md:mt-4">
            <div className="bg-red text-white px-8 py-3 rounded-b-xl text-2xl font-bold border-2 border-white ">
              SUNDAY FEAST
            </div>
          </div>
          <div className="SundayFeast-section-heading">
            <h1 className="SundayFeast-heading">
              Sunday Feast – A Celebration of Bhakti & Prasadam
            </h1>
            <h2 className="SundayFeast-subheading">
              Join Us for Kirtan, Krishna Talks, and Sumptuous Prasadam
            </h2>
          </div>
          {/* <h1 className="text-center text-[#c61d21] text-2xl lg:text-8xl font-bold font-['Open Sans'] sunday">
          Sunday Feast
        </h1> */}
          <div className="flex items-center  flex-col lg:flex-row lg:mt-7">
            <img
              src={img5}
              className="w-[304px] h-[193px] lg:w-[850px] lg:h-[540px] "
              alt="Prayer before annadan"
            />
            <div className="flex flex-col  justify-start items-start lg:h-[500px]">
              <p className="w-[350px] h-[29.16px] lg:w-[653px] lg:h-[85px]  text-[#c61d21] text-2xl lg:text-5xl font-semibold font-['Source Serif Pro'] capitalize text-center">
                Join Us for the Sunday Feast!
              </p>

              <p className="w-[350px] lg:w-[591px] lg:h-[313px] text-black lg:text-5xl font-light font-['Inter'] capitalize text-base text-justify">
                At <strong className="font-semibold">ISKCON Vijayawada,</strong>{" "}
                we invite you to experience the joy and devotion of our Sunday
                Feast. This weekly event is more than just a meal.
              </p>
            </div>
          </div>
          <p className="w-[350px] lg:w-[85rem] text-[#c61d21] textbase lg:text-4xl font-bold font-['Inter'] text-justify lg:text-start lg:my-16 mx-auto">
            It is an opportunity to come together as a community, nourish our
            bodies and souls, and immerse ourselves in the teachings of Lord
            Krishna
          </p>
        </div>

        <Slider1 />
        <Slider2 />

        <div className="w-full bg2 lg:bg-cover bg-center py-10 bg-contain">
          {/* Shehedule Of Event */}
          <div className="w-[382px] lg:w-[89.93rem] h-[317px] lg:h-[31.43rem] flex flex-col gap-2 lg:gap-12 items-center justify-center px-14 lg:py-10 bg-[#fff1df]/40 border-2 rounded-[5.19px] border-[#bc3521] backdrop-blur-[80.60px] mx-auto lg:mb-32 mb-10 lg:mt-20">
            <h2 className="text-2xl lg:text-6xl text-[#c61d21] font-bold lg:font-semibold font-['Source Serif'] lg:mt-10">
              Schedule of Events
            </h2>
            <div className="flex items-center justify-center gap-1 lg:gap-8  flex-col lg:flex-row ">
              <img
                src={img1}
                className="w-[189px] lg:w-[27.93rem] h-[110px] lg:h-[16.31rem] "
                alt="take divine blessings"
              />
              <ul className="w-[331px] lg:w-[50rem] list-disc text-start ">
                <li className="  ">
                  <p className="font-normal text-black font-['Open Sans'] lg:leading-[3.125rem] capitalize text-baase lg:text-3xl text-start m-0">
                    <strong className="  font-bold  ">Time : </strong>
                    Every Sunday from 8 AM to 11 AM.
                  </p>
                </li>
                <li>
                  <p className=" font-normal text-black font-['Open Sans'] lg:leading-[3.125rem] capitalize text-base lg:text-3xl text-start m-0">
                    <strong className=" font-bold  ">Location : </strong>
                    ISKCON Sri Radha Shyam Sundar Mandir, Vijayawada.
                  </p>
                </li>
              </ul>
            </div>
          </div>

          {/* Why Attend  */}
          <div className="w-full h-[1750px] lg:h-[56rem] bg-[#c61d21] lg:py-10 py-8 ">
            <h2 className="text-[#f3b01b] text-3xl lg:text-[4.25rem] font-semibold font-['Source Serif Pro'] capitalize text-center ">
              Why Attend?
            </h2>
            <div className="flex flex-col lg:flex-row gap-6 items-center justify-center mt-12">
              <div className="w-full lg:w-[41.68rem] flex-col flex justify-center items-center gap-6 lg:gap-14 ">
                <img
                  src={img2}
                  alt="take divine blessings"
                  className=" lg:w-[26.625rem] h-[342.95px] lg:h-[29.93rem]"
                />
                <div className="w-[305px] lg:w-[26.625rem] h-[8.25rem] flex-col justify-start items-start lg:gap-1.5 flex">
                  <p className="self-stretch text-justify text-[#f3b01b] text-2xl lg:text-4xl font-bold font-['Source Serif Pro'] capitalize">
                    Community Spirit
                  </p>
                  <p className="self-stretch text-justify text-white text-base lg:text-xl font-semibold font-['Open Sans'] capitalize">
                    Connect with fellow devotees and form lasting friendships
                    while sharing a meal in a joyful atmosphere.
                  </p>
                </div>
              </div>

              <div className="w-full lg:w-[41.68rem]  flex-col flex justify-center items-center gap-6 lg:gap-14 ">
                <img
                  src={img3}
                  alt="take divine blessings"
                  className="w-[305px] lg:w-[26.625rem] h-[342.95px] lg:h-[29.93rem]"
                />
                <div className="w-[305px] lg:w-[26.625rem] h-[8.25rem] flex-col justify-start items-start lg:gap-1.5 flex">
                  <p className="self-stretch text-justify text-[#f3b01b] text-2xl lg:text-4xl font-bold font-['Source Serif Pro'] capitalize">
                    Spiritual Nourishment
                  </p>
                  <p className="self-stretch text-justify text-white text-base lg:text-xl font-semibold font-['Open Sans'] capitalize">
                    Engage in devotional practices that enhance your spiritual
                    journey and bring you closer to Lord Krishna.
                  </p>
                </div>
              </div>
              <div className="w-full lg:w-[41.68rem]  flex-col flex justify-center items-center gap-6 lg:gap-14 ">
                <img
                  src={img4}
                  alt="take divine blessings"
                  className="w-[305px] lg:w-[26.625rem] h-[342.95px] lg:h-[29.93rem]"
                />
                <div className="w-[305px] lg:w-[26.625rem] h-[8.25rem] flex-col justify-start items-start lg:gap-1.5 flex">
                  <p className="self-stretch text-justify text-[#f3b01b] text-2xl lg:text-4xl font-bold font-['Source Serif Pro'] capitalize">
                    Family-Friendly
                  </p>
                  <p className="self-stretch text-justify text-white text-base lg:text-xl font-semibold font-['Open Sans'] capitalize">
                    Our Sunday Feast is a perfect outing for families, with
                    activities and programs suitable for all ages.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Join Us Section */}
          <div className="w-[97%] lg:w-[84%] flex flex-col justify-center mt-10 mx-auto rounded-md border-2 border-red md:text-3xl">
            <h2 className="text-center bg-red text-white font-bold text-lg p-2 md:p-8 md:text-4xl lg:mb-5">
              Join Us And Be A Part Of This Growing Tree Of Devotion!
            </h2>
            <p className="text-sm lg:text-3xl p-2 lg:mb-8 lg:text-center font-semibold">
              Be a part of our Saturday Satsang at ISKCON Sri Jagannath Mandir.
              Together, let us chant, learn, and serve in the spirit of
              devotion.
            </p>

            <div className="grid grid-cols-2 gap-4 p-1 lg:w-[90%] lg:mb-5 mx-auto">
              <div>
                <label className="block font-medium mb-1 ">Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full lg:w-[90%] bg-transparent p-2 border-2 border-solid border-gray-300 lg:border-gray-400 rounded-md focus:outline-none focus:ring-2 focus:ring-red"
                />
              </div>
              <div>
                <label className="block font-medium mb-1">Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full lg:w-[90%] p-2 bg-transparent  border-2 border-solid border-gray-300 lg:border-gray-400 rounded-md focus:outline-none focus:ring-2 focus:ring-red"
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4 p-1 lg:w-[90%] lg:mb-5 mx-auto">
              <div>
                <label className="block font-medium mb-1 ml-1 ">Phone</label>
                <input
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full lg:w-[90%] p-2 bg-transparent  border-2 border-solid border-gray-300 lg:border-gray-400 rounded-md focus:outline-none focus:ring-2 focus:ring-red"
                />
              </div>
              <div>
                <label className="block font-medium mb-1">Address</label>
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  className="w-full lg:w-[90%] p-2 bg-transparent  border-2 border-solid border-gray-300 lg:border-gray-400 rounded-md focus:outline-none focus:ring-2 focus:ring-red"
                />
              </div>
            </div>

            <div className="p-1 lg:w-[90%] mx-auto">
              <label className="block font-medium mb-1 ml-1">
                Special Note
              </label>
              <textarea
                name="specialNote"
                value={formData.specialNote}
                onChange={handleChange}
                className="w-full lg:mb-5 p-2 bg-transparent border-2 border-solid border-gray-300 lg:border-gray-400 rounded-md focus:outline-none focus:ring-2 focus:ring-red"
                rows="3"
              ></textarea>
            </div>

            <button
              onClick={handleSubmit}
              className="w-full lg:w-[90%] mx-auto mb-3 lg:mb-5 bg-red lg:text-4xl text-white font-bold py-2 px-2 lg:rounded-md"
            >
              Submit
            </button>

            <div className="w-[338px]  lg:w-[87.43rem] lg:h-[14.31rem] justify-center items-start gap-4 inline-flex flex-col lg:flex-row mt-2 mb-9  pl-7 lg:px-7">
              <div className="w-full lg:w-[22.87rem] h-[145px] lg:h-[14.31rem] relative bg-[#fff0dc] rounded-xl border-2 border-[#c20000] flex-col justify-start items-start flex lg:py-5 py-2 px-4 lg:px-7">
                <div className="w-[60px] lg:w-[5.43rem] text-[#c61d21] text-2xl lg:text-4xl font-bold font-['Lato'] leading-[38px] lg:leading-9">
                  RSVP
                </div>
                <div className="h-[51px] lg:w-[15.93] lg:h-12 text-[#c61d21] text-base lg:text-xl font-normal font-['Lato'] leading-relaxed ">
                  Please let us know if you’ll be joining us by
                </div>
                <div className="flex gap-1 lg:gap-3 items-center justify-center lg:mt-8 mx-auto w-full">
                  <span className="text-xl lg:text-2xl text-[#c61d21]">
                    <CgMail />
                  </span>
                  <p className="text-black text-base lg:text-xl font-semibold font-['Open Sans'] ">
                    seva@iskconvijayawada.org
                  </p>
                </div>
              </div>
              <div className="w-full h-[229px] px-6 py-10  grow shrink basis-0 self-stretch lg:px-12 lg:py-[41px] bg-[#c61d21] rounded-[10px] border-2 border-[#c61d21] flex-col justify-start items-start gap-2.5 inline-flex donation">
                <div className="w-[277px] h-[166px] lg:w-[880px] lg:h-[135px] flex-col justify-start items-start gap-6 lg:gap-[22px] flex">
                  <div className="self-stretch text-[#ffdebd] text-2xl lg:text-4xl font-bold font-['Open Sans'] leading-[38px]">
                    Donations
                  </div>
                  <div className="self-stretch  text-[#ffdebd] text-base lg:text-2xl font-normal font-['Lato'] leading-relaxed">
                    While the feast is free, we welcome donations to help
                    support our ongoing programs and community service
                    initiatives.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}

export default SundayFeast;
